"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InputPopoverExample = void 0;
var tslib_1 = require("tslib");
var mithril_1 = tslib_1.__importDefault(require("mithril"));
var _1 = require("@/");
var examples_1 = require("@shared/examples");
var EXAMPLE_SRC = 'components/input-popover/examples/index.ts';
var InputPopoverExample = /** @class */ (function () {
    function InputPopoverExample() {
        this.type = 'input';
        this.highlightOnOpen = false;
        this.submitOnEnter = true;
        this.value = 'Value';
    }
    InputPopoverExample.prototype.view = function () {
        var _this = this;
        return (0, mithril_1.default)(examples_1.Example, { options: this.renderOptions(), src: EXAMPLE_SRC }, [
            (0, mithril_1.default)(_1.InputPopover, {
                type: this.type,
                header: this.header && 'Header',
                footer: this.footer && 'Footer',
                submitOnEnter: this.submitOnEnter,
                hightlightOnOpen: this.highlightOnOpen,
                placeholder: 'Enter value',
                onSubmit: function (value) { return _this.value = value; },
                value: this.value,
                trigger: (0, mithril_1.default)(_1.Button, {
                    sublabel: 'Trigger: ',
                    label: this.value,
                    iconRight: _1.Icons.CHEVRON_DOWN
                })
            })
        ]);
    };
    InputPopoverExample.prototype.renderOptions = function () {
        var _this = this;
        return [
            (0, mithril_1.default)('h5', 'Type'),
            (0, mithril_1.default)(_1.Select, {
                options: ['input', 'textarea'],
                onchange: function (e) { return _this.type = e.target.value; },
                size: 'xs'
            }),
            (0, mithril_1.default)(_1.Switch, {
                checked: this.header,
                label: 'Header',
                onchange: function () { return _this.header = !_this.header; }
            }),
            (0, mithril_1.default)(_1.Switch, {
                checked: this.footer,
                label: 'Footer',
                onchange: function () { return _this.footer = !_this.footer; }
            }),
            (0, mithril_1.default)(_1.Switch, {
                checked: this.submitOnEnter,
                label: 'Submit on enter',
                onchange: function () { return _this.submitOnEnter = !_this.submitOnEnter; }
            }),
            (0, mithril_1.default)(_1.Switch, {
                checked: this.highlightOnOpen,
                label: 'Highlight on open',
                onchange: function () { return _this.highlightOnOpen = !_this.highlightOnOpen; }
            })
        ];
    };
    return InputPopoverExample;
}());
exports.InputPopoverExample = InputPopoverExample;
